import getApiClient from '@/plugins/api-client'
import { parseFilters } from '@/util/helpers'

export default {
  loadOrders: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
      ...this.filters,
      ...this.pagination.getParams(),
    })

    api.get('orders', { params })
      .then(result => {
        this.orders = result.data['hydra:member']
        this.pagination.updateData(result.data)
      })
      .catch(error => {
        this.error = error
      })
  },

  clearFilters () {
    this.filters = {}
    if (this.$route.params.email) {
      this.$route.params.email = null
      this.$router.push(this.$route)
    } else {
      this.loadOrders()
    }
  },

  exportOrders: function () {
    const api = getApiClient(this.$store)

    const params = parseFilters({
        ...this.filters,
      },
    )

    api.get('orders/export', { params }, { responseType: 'blob' })
      .then(result => {
        const url = window.URL.createObjectURL(new Blob([result.data]))
        const link = document.createElement('a')

        link.href = url
        link.setAttribute('download', 'export.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.log(error)
      })
  },
}
